import React,{useState, useEffect} from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ServiceEdit from "./Components/ServiceEdit";
import GalleryTemplateEdit from "./Components/GalleryTemplateEdit";
import OfferSection from "./Components/OfferSection";
import AppointmentTable from "./Components/AppointmentTable";

const AdminPage=()=>{

    useEffect(()=>{
        document.title="Admin | Janushree"
      },[]);

    return(
        <>
            <Header/>
                <AppointmentTable/>
            <Footer/>
        </>
    );
}

export default AdminPage;